
export function NewzealandEntitySearchBoxSegment(props: {
	entityName: string,
	entityStatus: string,
	entityNcn: string,
}) {
	const {
		entityName,
		entityStatus,
		entityNcn
	} = props;

	return (
		<section className="review-segment">
			<div>
				<p><strong>Entity name: </strong>{entityName}</p>
				<p><strong>Entity status: </strong>{entityStatus}</p>
				<p><strong>Registration Number:</strong> {entityNcn}</p>
			</div>
		</section>
	)
}